import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Download, FileDown, Loader2, Mail } from "lucide-react";

export default function EmailCopy() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState("");

  useEffect(() => {
    api.get(`/email-copies/${token}`).then((r) => setInfo(r.data))
      .catch((e) => setError(formatApiError(e.response?.data?.detail) || "This link isn't available."));
  }, [token]);

  const download = async (kind) => {
    setBusy(kind);
    try {
      const res = await api.get(`/email-copies/${token}/${kind}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = `${info.form_number}${kind === "packet" ? "-filing-packet" : ""}.pdf`; a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Could not download the file");
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-1 w-full max-w-2xl mx-auto px-6 py-20" data-testid="email-copy-page">
        <p className="overline text-accent mb-3 flex items-center gap-2"><Mail size={14} /> Your emailed copy</p>
        {error && <p className="text-muted-foreground" data-testid="email-copy-error">{error} <Link to="/saved" className="text-accent underline">Go to my saved forms</Link></p>}
        {!error && !info && <p className="text-muted-foreground animate-pulse">Loading…</p>}
        {info && (
          <div className="grid-card p-8">
            <h1 className="font-serif font-bold text-3xl text-foreground" data-testid="email-copy-title">{info.form_number}</h1>
            <p className="text-muted-foreground mt-1">{info.title}</p>
            <p className="text-xs text-muted-foreground mt-3" data-testid="email-copy-expiry">
              Link works until {new Date(info.expires_at).toLocaleDateString()}
            </p>
            <div className="flex flex-wrap gap-3 mt-6">
              <Button onClick={() => download("form")} disabled={!!busy} data-testid="email-copy-download-form" className="rounded-sm gap-2">
                {busy === "form" ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />} Completed PDF
              </Button>
              <Button onClick={() => download("packet")} disabled={!!busy} variant="outline" data-testid="email-copy-download-packet" className="rounded-sm gap-2">
                {busy === "packet" ? <Loader2 size={16} className="animate-spin" /> : <FileDown size={16} />} Filing Packet
              </Button>
            </div>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
